function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.75 4.99999C2.27034 1.96388 4.69091 0 7.41727 0C10.1436 0 12.5642 1.96388 14.0845 4.99999C12.5642 8.0361 10.1436 9.99998 7.41727 9.99998C4.69091 9.99998 2.27034 8.0361 0.75 4.99999Z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.75 4.99999L-0.144158 4.55224L-0.368371 4.99999L-0.144158 5.44774L0.75 4.99999ZM14.0845 4.99999L14.9787 5.44774L15.2029 4.99999L14.9787 4.55224L14.0845 4.99999ZM1.64416 5.44774C3.07119 2.59797 5.21398 1 7.41727 1V-1C4.16784 -1 1.46949 1.32979 -0.144158 4.55224L1.64416 5.44774ZM7.41727 1C9.62055 1 11.7633 2.59797 13.1904 5.44774L14.9787 4.55224C13.365 1.32979 10.6667 -1 7.41727 -1V1ZM13.1904 4.55224C11.7633 7.40201 9.62055 8.99998 7.41727 8.99998V11C10.6667 11 13.365 8.67019 14.9787 5.44774L13.1904 4.55224ZM7.41727 8.99998C5.21398 8.99998 3.07119 7.40201 1.64416 4.55224L-0.144158 5.44774C1.46949 8.67019 4.16784 11 7.41727 11V8.99998Z",
  fill: "currentColor",
  mask: "url(#path-1-inside-1)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 7.5,
  cy: 4.5,
  r: 2.5,
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 0.251935,
  y1: 0.568111,
  x2: 15.2519,
  y2: 9.31811,
  stroke: "currentColor"
});

var SvgEyeCrossed = function SvgEyeCrossed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeCrossed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyeCrossed.05982683.svg";
export { ForwardRef as ReactComponent };